import { css as r, styled as l } from "@lokalise/styled";
import u from "react-select";
import { value as o, typography as d, spacing as i } from "../../utils/theme/index.js";
import { oneLineEllipsis as p } from "../../utils/styles/oneLineEllipsis.js";
import { withInputContainerStyle as _, withInputDisabledStyle as g, withInputFieldStyle as x } from "../../utils/styles/inputStyle.js";
import { Close as f } from "../../foundations/icons/Close.js";
const c = "LouisSelect-focus_outline_should_be_visible", a = r`
	// Padding is added, so MultiValueLabel Item text, could be seen in full size
	padding: 1px;
	color: ${o("color.text.default")};
	font-size: 14px;
	line-height: 15px;
`, k = l.div`
	${p};
	${a};
	max-width: 200px;
`, s = r`
	background-color: ${o("color.background.surface.fore")};
	border-radius: ${o("radius.m")};
	padding: 1px;
	margin: 0;
`, v = r`
	${s};
	${a};
	padding: 5px;
`, y = l.div`
	${v}
`, C = l.div`
	max-width: 200px;
`, L = l(u)`
	${d("body.small.default")};
	width: 100%;

	.Select__option {
		font-family: ${o("font.family.default")};
	}

	.Select__option--is-disabled {
		color: ${o("color.text.disabled")};
		cursor: not-allowed;
	}

	.Select__control {
		${() => (
  /* stupid hack to get rid of some type errors */
  r`
			${_}
		`
)};
		height: unset;
		line-height: unset;
		min-height: ${o("size.height.input.default")};
		padding: 0;
	}
	.Select__control--is-focused,
    /* This second selector is required to make sure hover rule is not overriding focus */
    .Select__control--is-focused:hover {
		border-color: ${o("color.border.active")};
		outline: none;
		box-shadow: none;
	}
	.Select__control--is-disabled {
		${g};

		.Select__placeholder {
			color: ${o("color.text.disabled")};
		}

		.Select__multi-value__label {
			padding: 2.5px 8px;
		}
	}
	.Select__multi-value {
		${s}
	}

	.Select__multi-value__remove svg {
		color: ${o("color.text.light.default")};
		fill: currentColor;
		cursor: pointer;
	}
	.Select__multi-value__remove:hover {
		background-color: transparent;
		svg {
			background-color: transparent;
			color: ${o("color.text.link.hover")};
		}
	}
	.Select__multi-value__remove svg {
		width: 16px;
		height: 16px;
	}
	.Select__menu-notice--no-options {
		font-family: ${o("font.family.default")};
	}
	.Select__indicator {
		padding: 6px 8px;
	}
	.Select__input-container {
		overflow: hidden;
	}
	&&& .Select__input {
		font-size: 14px;
		line-height: 16px;
		color: ${o("color.text.default")};

		&:focus {
			outline: none !important;
		}
	}
	.Select__indicators {
		color: ${o("color.border.input.default")};
	}
	.Select__clear-indicator,
	.Select__dropdown-indicator,
	.Select__clear-indicator svg,
	.Select__dropdown-indicator svg {
		cursor: pointer;
		color: currentColor;
		fill: currentColor;
	}
	.Select__clear-indicator {
		padding: 0px;
		margin-right: 4px;
		font-size: 16px;
		height: 16px;
	}
	.Select__dropdown-indicator {
		padding: 0px 12px 0px 0px;
		font-size: 24px;
		height: 24px;
	}
	&:not(.Select--is-disabled) {
		.Select__clear-indicator:hover {
			color: ${o("color.text.link.hover")};
		}
		&:hover,
		[data-dev-state='hover'] & {
			.Select__dropdown-indicator {
				color: ${o("color.border.input.hover")};
			}
		}
		[data-dev-state='focus'] & .Select__dropdown-indicator,
		.Select__control--menu-is-open .Select__dropdown-indicator {
			transform: scaleY(-1);
			color: ${o("color.border.active")};
		}
	}
	.Select__placeholder,
	.Select__single-value {
		font-size: 14px;
		padding: 0;
		margin: 0;
		color: ${o("color.text.input.placeholder")};
	}
	.Select__single-value {
		color: ${o("color.text.default")};
	}
	.Select__indicator-separator {
		display: none;
	}
	.Select__value-container {
		${() => (
  /* stupid hack to get rid of some type errors */
  r`
			${x}
		`
)};

		padding: 4px 12px;
	}
	.Select__value-container--is-multi {
		gap: ${i(1)};
		padding: ${i(1, 2)};
	}
`, z = l.div`
	width: 100%;
	display: grid;
	gap: ${i(1)};
	grid-template-columns: minmax(50px, 1fr); /* This ensures Select doesn't overflow 100% */

	&:has(.Select--is-disabled) {
		cursor: not-allowed;
	}

	// While using keyboard navigation, show active background on focused option
	&.${c} .Select__option--is-focused {
		background-color: ${o("color.background.active")};
	}

	// While hovering, only show active background on hovered option, do not show active background on focused option
	&:not(.${c}) .Select__menu:hover .Select__option:not(.Select__option--is-disabled) {
		background-color: ${o("color.background.input.default")};
	}
	&:not(.${c}) .Select__menu .Select__option:hover:not(.Select__option--is-disabled) {
		background-color: ${o("color.background.active")};
	}
`, I = l(f)`
	pointer-events: inherit;

	* {
		pointer-events: inherit;
	}
`, M = l.div`
	display: flex;
`, V = (e) => ({
  input: (t) => ({
    ...t,
    margin: 0,
    color: o("color.text.default")({ theme: e }),
    overflow: "hidden"
  }),
  menu: (t) => ({
    ...t,
    backgroundColor: o("color.background.input.default")({ theme: e }),
    border: `1px solid ${o("color.border.input.default")({ theme: e })}`,
    boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
    margin: i(1, 0, 0)({ theme: e }),
    zIndex: o("zIndex.dropdown")({ theme: e })
  }),
  noOptionsMessage: (t) => ({
    ...t,
    ...d("body.small.default")({ theme: e }),
    color: o("color.text.disabled")({ theme: e }),
    textAlign: "left"
  }),
  option: (t, n) => ({
    ...t,
    fontFamily: o("font.family.default")({ theme: e }),
    fontSize: "14px",
    lineHeight: "16px",
    padding: "8px 14px 9px",
    color: o("color.text.default")({ theme: e }),
    cursor: "pointer",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%",
    minWidth: "100%",
    // eslint-disable-next-line no-underscore-dangle
    ...n.data.__isNew__ ? { color: o("color.text.active")({ theme: e }) } : {},
    ...n.isSelected ? {
      background: "none",
      color: o("color.text.default")({ theme: e }),
      /**
       * For the selected option we originally were setting `display: flex` but combination of flex + text-overflow
       * was not working correctly. Instead, for the selected option, we instead have the icon to be positioned
       * absolutely and shift it left while simultaneously adding same amount of padding left to the selected option.
       *
       * 16px – icon width, 14px – original padding (above), 1 spacing – gap
       */
      paddingLeft: `calc(16px + 14px + ${i(1)({ theme: e })})`,
      "&::before": {
        width: 16,
        height: 16,
        position: "absolute",
        // 16px icon width + 1 spacing
        marginLeft: `calc(-16px - ${i(1)({ theme: e })})`,
        content: '""',
        flex: "0 0 auto",
        verticalAlign: "middle",
        backgroundSize: "16px 16px",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.64372 10.1336L3.58684 7.07669L2.65918 8.01319L6.65255 12.0066L12.9872 5.65427L12.0507 4.71777L6.64372 10.1336Z' fill='${encodeURIComponent(
          o("color.text.default")({ theme: e })
        )}'/%3E%3C/svg%3E%0A")`
      }
    } : void 0,
    ...n.isFocused ? {
      background: o("color.background.active")({ theme: e }),
      color: o("color.text.default")({ theme: e })
    } : void 0
  }),
  // No access to props inside menuPortal
  menuPortal: (t) => ({ ...t, zIndex: e.zIndex.dropdownInPortal }),
  menuList: (t, n) => ({ ...t, maxHeight: n.selectProps.maxMenuHeight }),
  valueContainer: (t) => ({ ...t, overflow: "hidden" })
});
export {
  z as Container,
  k as MultiValueLabelText,
  y as MultiValueMore,
  C as MultiValueMoreTooltipContent,
  M as RemoveButtonContainer,
  I as StyledCloseIcon,
  L as StyledSelect,
  c as focusOutlineVisibilityClassName,
  V as selectStyles
};
//# sourceMappingURL=styles.js.map
